export default __webpack_public_path__ + "static/media/logo_new_small.ae899c3e.svg";